import { useEffect, useMemo, useState } from 'react';
import quickFetch from 'quick-fetch';
import { COOKIE_ECHO_USER } from '../constants/EarlyRequesterNames';
import { getOverrideLocaleParam } from '../utils/getPreferredLanguage';
function isHubSpotEmailResponse(response) {
  if (typeof response !== 'object' || response === null) return false;
  const email = response.email;
  return typeof email === 'string' && email.endsWith('@hubspot.com');
}
export function useIsOverrideLocaleActive() {
  const hasOverrideParam = useMemo(() => Boolean(getOverrideLocaleParam()), []);
  const [isHubSpotUser, setIsHubSpotUser] = useState(false);
  useEffect(() => {
    if (!hasOverrideParam) return;
    const earlyRequest = quickFetch.getRequestStateByName(COOKIE_ECHO_USER);
    if (!earlyRequest) return;
    earlyRequest.whenFinished(response => {
      setIsHubSpotUser(isHubSpotEmailResponse(response));
    });
  }, [hasOverrideParam]);
  return hasOverrideParam && isHubSpotUser;
}